import CasesFirstViewWhite from 'components/cases/common/CasesFirstViewWhite/CasesFirstViewWhite'

export default CasesFirstViewWhite
